class PickupAvailability extends HTMLElement {
  constructor() {
    super();
    if (!this.hasAttribute('data-variant-id')) return;
    
    this.fetchAvailability(this.getAttribute('data-variant-id'));
  }

  fetchAvailability(variantId) {
    const rootUrl = this.getAttribute('data-root-url');
    // We request the variant via its URL and specify section_id=pickup-availability
    // In Shopify, the standard route is /variants/ID/?section_id=... or /products/HANDLE?variant=ID&section_id=...
    // Let's use the current window location to append variant and section_id.
    const url = new URL(window.location.href);
    url.searchParams.set('variant', variantId);
    url.searchParams.set('section_id', 'pickup-availability');

    fetch(url.toString())
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const availability = html.querySelector('.pickup-availability-preview');
        
        if (availability) {
          this.innerHTML = availability.outerHTML;
        }
      })
      .catch(e => {
        console.error('Error fetching pickup availability', e);
      });
  }
}

customElements.define('pickup-availability', PickupAvailability);
